import { h } from "../dom.ts";
import { t } from "../i18n/index.ts";
import { readPlayer } from "../play/client.ts";
import { playerPreferences, signOutControl } from "../play/profile.ts";
import { appearancePreferences, boardPreferences } from "../ui/preferences.ts";
import { playPage } from "./play.ts";
import { saveGamesPanel } from "./myGames.ts";
import { telegramSettings } from "./telegramSettings.ts";

export function settingsScreen(connect = false): HTMLElement {
  const root = playPage(`<h1>${t("settings.title")}</h1><p class="fine">${t("settings.browserScope")}</p>`, null);
  const main = root.querySelector("main")!;
  const board = h(`<section class="panel"><h2>${t("settings.boardGroup")}</h2></section>`);
  board.append(boardPreferences("all"));
  const account = h(`<section class="panel"><h2>${t("settings.accountGroup")}</h2><p data-account-status role="status"></p></section>`);
  account.append(playerPreferences(), saveGamesPanel());
  main.append(appearancePreferences(), board, account);
  const status = account.querySelector<HTMLElement>("[data-account-status]")!;
  void readPlayer().then(player => {
    status.textContent = player ? t(player.kind === "account" ? "library.signedIn" : "library.guest", {name: player.username}) : t("settings.guestAccount");
    if (player) account.append(signOutControl());
  }).catch(() => { status.textContent = t("settings.accountFailed"); });
  account.append(telegramSettings(connect));
  return root;
}
